export default __webpack_public_path__ + "static/media/lemontbotanique_grid_xl.187af27f.jpg";